
import { Swipe as SwipeInstance } from 'react-sdk/activities/Swipe';
import classes from './Swipe.module.css';
import SwipeGame from './SwipeGame';
import SwipeRecap from './SwipeRecap';
import { observer } from 'mobx-react-lite';

/**
 *
 * @param {object} props
 * @param {SwipeInstance} props.instance
 * @returns
 */
const Swipe = ({instance, onReadyToValidate}) => {
  function correct() {
    instance.localCorrect()
    onReadyToValidate()
  }

  return (
    <div className={classes.Swipe}>
    {!instance.result &&
    <SwipeGame instance={instance} onDone={correct} />}

    {instance.result  &&
    <SwipeRecap instance={instance} />}



    </div>
  );
};

export default observer(Swipe);
